import API from '@/api'
import router from '@/router'

export const moduleName = 'salesRevenueManager'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_JOIN_TO_SALES_REVENUE_MANAGER: 'ACTION_JOIN_TO_SALES_REVENUE_MANAGER',
  ACTION_LOAD_AUCTIONS: 'ACTION_LOAD_AUCTIONS',
}

export const getterTypes = {
  GETTER_AUCTIONS: 'GETTER_AUCTIONS',
  GETTER_AUCTIONS_COUNT: 'GETTER_AUCTIONS_COUNT',
  GETTER_TOTAL_REVENUE: 'GETTER_TOTAL_REVENUE'
}

export const mutationTypes = {
  MUTATION_SET_AUCTIONS: 'SET_AUCTIONS',
  MUTATION_ADD_AUCTION: 'MUTATION_ADD_AUCTION'
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    auctions: [],
    auctionsCount: 0,
    totalRevenue: 0,
    carForm: {
      images: []
    },
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ _, dispatch }) {
      const onCarEnded = ({ value }) => {
        dispatch(actionTypes.ACTION_LOAD_AUCTIONS, {
          take: router.currentRoute.query.take,
          skip: router.currentRoute.query.skip,
          search: router.currentRoute.query.search,
          all: true
        })
      }

      API.salesRevenueManager.wsListeners[API.salesRevenueManager.wsEvents.CAR_MANAGER_CAR_ENDED](onCarEnded)
    },

    [actionTypes.ACTION_JOIN_TO_SALES_REVENUE_MANAGER]() {
      API.salesRevenueManager.wsActions.ACTION_JOIN_TO_CAR_MANAGER()
    },

    async [actionTypes.ACTION_LOAD_AUCTIONS] ({ commit }, payload) {
      const result = await API.salesRevenueManager.loadSalesRevenue(payload)
      const { cars, carsCount, totalRevenue } = result.data
      commit(mutationTypes.MUTATION_SET_AUCTIONS, [cars, carsCount, totalRevenue])
    },
  },

  mutations: {
    [mutationTypes.MUTATION_SET_AUCTIONS](state, [auctions, auctionsCount, totalRevenue]) {
      state.auctions = auctions
      state.auctionsCount = auctionsCount
      state.totalRevenue = totalRevenue
    },
    [mutationTypes.MUTATION_ADD_AUCTION](state, auction) {
      if (state.auctions.some(c => c.id === auction.id)) return
      const maxAuctions = Number(router.currentRoute.query.take) || 10

      state.auctions.unshift(auction)
      if (state.auctions.length > maxAuctions) {
        state.auctions.pop()
      }
    },
  },

  getters: {
    [getterTypes.GETTER_AUCTIONS]: (state) => state.auctions,
    [getterTypes.GETTER_AUCTIONS_COUNT]: (state) => state.auctionsCount,
    [getterTypes.GETTER_TOTAL_REVENUE]: (state) => state.totalRevenue
  }
}
